<script>
  import Header from "../Component/Header.svelte";
  import { Button } from "../../Components";

  export let congressId;

  let congressYear;
  // const widgetView = "imkanmeldung";
</script>

<Header {congressId} {congressYear} />

<div class="flex items-center justify-center">
  <Button main class="mt-8" eventOnClick="openLoginModal">Anmeldung</Button>
</div>
